import clsx from 'clsx';
import { ASSET_PREFIX } from 'utils/constants';

import styles from './ZealVariant.module.css';

interface IProp {
  animatePopup: boolean;
  allowAllClick: () => void;
  acceptNecessaryClick: () => void;
  expandCookiePreferences: () => void;
}

const commonButtonStyles = clsx(styles.button, 'uppercase', 'bold');
const secondaryButtonStyles = styles.secondaryButton;
export const ZealVariant = ({
  animatePopup,
  allowAllClick,
  acceptNecessaryClick,
  expandCookiePreferences,
}: IProp) => {
  return (
    <div
      className={styles.overlay}
      style={{
        ...(animatePopup
          ? { transform: 'translateY(0)' }
          : { transform: 'translateY(120%)' }),
      }}
    >
      <div className={styles.popup}>
        <img
          className={styles.logo}
          src={`${ASSET_PREFIX}/images/daymade-logo-no-text.png`}
        />
        <p className={styles.heading}>
          We want to give you <br />
          the best DAYMADE experience.
        </p>
        <p className={styles.description}>
          We provide a personalised experience tailored to your preferences,
          using cookies and tools to analyse your usage. This helps ups deliver
          relevant information, even when you’re not on our website. The data we
          collect is also used to personalise ads from us and our partners. By
          clicking “Accept all”, you agree to this. You can change your consent
          at any time in the privacy settings. For more details, please see our{' '}
          <a className="underline" href="/privacy-policy">
            Privacy Policy
          </a>
        </p>

        <div className={styles.buttonList}>
          <button
            onClick={allowAllClick}
            className={clsx(commonButtonStyles, styles.primaryButton)}
          >
            accept all
          </button>
          <button
            onClick={acceptNecessaryClick}
            className={clsx(commonButtonStyles, secondaryButtonStyles)}
          >
            accept only necessary
          </button>
          <button
            onClick={expandCookiePreferences}
            className={clsx(commonButtonStyles, secondaryButtonStyles)}
          >
            customise cookies
          </button>
        </div>
      </div>
    </div>
  );
};
